/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type CancelPaymentBody,
    CancelPaymentBodyFromJSON,
    CancelPaymentBodyToJSON,
} from '../models/CancelPaymentBody';
import {
    type CancelTerminalPaymentBody,
    CancelTerminalPaymentBodyFromJSON,
    CancelTerminalPaymentBodyToJSON,
} from '../models/CancelTerminalPaymentBody';
import {
    type ErrorMessage,
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
} from '../models/ErrorMessage';
import {
    type GetTerminalDto,
    GetTerminalDtoFromJSON,
    GetTerminalDtoToJSON,
} from '../models/GetTerminalDto';
import {
    type PaymentEventDto,
    PaymentEventDtoFromJSON,
    PaymentEventDtoToJSON,
} from '../models/PaymentEventDto';
import {
    type PaymentStateResponse,
    PaymentStateResponseFromJSON,
    PaymentStateResponseToJSON,
} from '../models/PaymentStateResponse';
import {
    type TerminalStatusResponse,
    TerminalStatusResponseFromJSON,
    TerminalStatusResponseToJSON,
} from '../models/TerminalStatusResponse';
import {
    type TerminalWithLatestPaymentResponse,
    TerminalWithLatestPaymentResponseFromJSON,
    TerminalWithLatestPaymentResponseToJSON,
} from '../models/TerminalWithLatestPaymentResponse';

export interface CancelPayment1Request {
    locationId: number;
    paymentReference: string;
    cancelPaymentBody: CancelPaymentBody;
}

export interface CancelRefundRequest {
    locationId: number;
    paymentReference: string;
    cancelPaymentBody: CancelPaymentBody;
}

export interface GetLatestPaymentEventRequest {
    locationId: number;
    paymentReference: string;
}

export interface GetPaymentStateRequest {
    locationId: number;
    paymentReference: string;
}

export interface GetTerminalStatusRequest {
    locationId: number;
    pspTerminalId: string;
}

export interface GetTerminalsRequest {
    locationId: number;
    ids: Array<string>;
}

export interface GetTerminalsWithOngoingPaymentsRequest {
    locationId: number;
    ids: Array<string>;
}

export interface InitiateCancelAllRequest {
    locationId: number;
    paymentReference: string;
    cancelTerminalPaymentBody: CancelTerminalPaymentBody;
}

export interface InitiateCancelAppSwitchRequest {
    locationId: number;
    paymentReference: string;
    cancelTerminalPaymentBody: CancelTerminalPaymentBody;
}

/**
 * 
 */
export class EposClientControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for cancelPayment1 without sending the request
     */
    async cancelPayment1RequestOpts(requestParameters: CancelPayment1Request): Promise<runtime.RequestOpts> {
        if (requestParameters['locationId'] == null) {
            throw new runtime.RequiredError(
                'locationId',
                'Required parameter "locationId" was null or undefined when calling cancelPayment1().'
            );
        }

        if (requestParameters['paymentReference'] == null) {
            throw new runtime.RequiredError(
                'paymentReference',
                'Required parameter "paymentReference" was null or undefined when calling cancelPayment1().'
            );
        }

        if (requestParameters['cancelPaymentBody'] == null) {
            throw new runtime.RequiredError(
                'cancelPaymentBody',
                'Required parameter "cancelPaymentBody" was null or undefined when calling cancelPayment1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/locations/{locationId}/payments/{paymentReference}/cancel-payment`;
        urlPath = urlPath.replace('{locationId}', encodeURIComponent(String(requestParameters['locationId'])));
        urlPath = urlPath.replace('{paymentReference}', encodeURIComponent(String(requestParameters['paymentReference'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CancelPaymentBodyToJSON(requestParameters['cancelPaymentBody']),
        };
    }

    /**
     */
    async cancelPayment1Raw(requestParameters: CancelPayment1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.cancelPayment1RequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async cancelPayment1(requestParameters: CancelPayment1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cancelPayment1Raw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for cancelRefund without sending the request
     */
    async cancelRefundRequestOpts(requestParameters: CancelRefundRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['locationId'] == null) {
            throw new runtime.RequiredError(
                'locationId',
                'Required parameter "locationId" was null or undefined when calling cancelRefund().'
            );
        }

        if (requestParameters['paymentReference'] == null) {
            throw new runtime.RequiredError(
                'paymentReference',
                'Required parameter "paymentReference" was null or undefined when calling cancelRefund().'
            );
        }

        if (requestParameters['cancelPaymentBody'] == null) {
            throw new runtime.RequiredError(
                'cancelPaymentBody',
                'Required parameter "cancelPaymentBody" was null or undefined when calling cancelRefund().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/locations/{locationId}/payments/{paymentReference}/cancel-refund`;
        urlPath = urlPath.replace('{locationId}', encodeURIComponent(String(requestParameters['locationId'])));
        urlPath = urlPath.replace('{paymentReference}', encodeURIComponent(String(requestParameters['paymentReference'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CancelPaymentBodyToJSON(requestParameters['cancelPaymentBody']),
        };
    }

    /**
     */
    async cancelRefundRaw(requestParameters: CancelRefundRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.cancelRefundRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async cancelRefund(requestParameters: CancelRefundRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cancelRefundRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getLatestPaymentEvent without sending the request
     */
    async getLatestPaymentEventRequestOpts(requestParameters: GetLatestPaymentEventRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['locationId'] == null) {
            throw new runtime.RequiredError(
                'locationId',
                'Required parameter "locationId" was null or undefined when calling getLatestPaymentEvent().'
            );
        }

        if (requestParameters['paymentReference'] == null) {
            throw new runtime.RequiredError(
                'paymentReference',
                'Required parameter "paymentReference" was null or undefined when calling getLatestPaymentEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/locations/{locationId}/payments/{paymentReference}/events/latest`;
        urlPath = urlPath.replace('{locationId}', encodeURIComponent(String(requestParameters['locationId'])));
        urlPath = urlPath.replace('{paymentReference}', encodeURIComponent(String(requestParameters['paymentReference'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getLatestPaymentEventRaw(requestParameters: GetLatestPaymentEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaymentEventDto>> {
        const requestOptions = await this.getLatestPaymentEventRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentEventDtoFromJSON(jsonValue));
    }

    /**
     */
    async getLatestPaymentEvent(requestParameters: GetLatestPaymentEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaymentEventDto> {
        const response = await this.getLatestPaymentEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPaymentState without sending the request
     */
    async getPaymentStateRequestOpts(requestParameters: GetPaymentStateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['locationId'] == null) {
            throw new runtime.RequiredError(
                'locationId',
                'Required parameter "locationId" was null or undefined when calling getPaymentState().'
            );
        }

        if (requestParameters['paymentReference'] == null) {
            throw new runtime.RequiredError(
                'paymentReference',
                'Required parameter "paymentReference" was null or undefined when calling getPaymentState().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/locations/{locationId}/payments/{paymentReference}`;
        urlPath = urlPath.replace('{locationId}', encodeURIComponent(String(requestParameters['locationId'])));
        urlPath = urlPath.replace('{paymentReference}', encodeURIComponent(String(requestParameters['paymentReference'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPaymentStateRaw(requestParameters: GetPaymentStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaymentStateResponse>> {
        const requestOptions = await this.getPaymentStateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentStateResponseFromJSON(jsonValue));
    }

    /**
     */
    async getPaymentState(requestParameters: GetPaymentStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaymentStateResponse> {
        const response = await this.getPaymentStateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getTerminalStatus without sending the request
     */
    async getTerminalStatusRequestOpts(requestParameters: GetTerminalStatusRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['locationId'] == null) {
            throw new runtime.RequiredError(
                'locationId',
                'Required parameter "locationId" was null or undefined when calling getTerminalStatus().'
            );
        }

        if (requestParameters['pspTerminalId'] == null) {
            throw new runtime.RequiredError(
                'pspTerminalId',
                'Required parameter "pspTerminalId" was null or undefined when calling getTerminalStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/locations/{locationId}/terminals/{pspTerminalId}/status`;
        urlPath = urlPath.replace('{locationId}', encodeURIComponent(String(requestParameters['locationId'])));
        urlPath = urlPath.replace('{pspTerminalId}', encodeURIComponent(String(requestParameters['pspTerminalId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getTerminalStatusRaw(requestParameters: GetTerminalStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TerminalStatusResponse>> {
        const requestOptions = await this.getTerminalStatusRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TerminalStatusResponseFromJSON(jsonValue));
    }

    /**
     */
    async getTerminalStatus(requestParameters: GetTerminalStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TerminalStatusResponse> {
        const response = await this.getTerminalStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getTerminals without sending the request
     */
    async getTerminalsRequestOpts(requestParameters: GetTerminalsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['locationId'] == null) {
            throw new runtime.RequiredError(
                'locationId',
                'Required parameter "locationId" was null or undefined when calling getTerminals().'
            );
        }

        if (requestParameters['ids'] == null) {
            throw new runtime.RequiredError(
                'ids',
                'Required parameter "ids" was null or undefined when calling getTerminals().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/locations/{locationId}/terminals`;
        urlPath = urlPath.replace('{locationId}', encodeURIComponent(String(requestParameters['locationId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getTerminalsRaw(requestParameters: GetTerminalsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetTerminalDto>>> {
        const requestOptions = await this.getTerminalsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetTerminalDtoFromJSON));
    }

    /**
     */
    async getTerminals(requestParameters: GetTerminalsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetTerminalDto>> {
        const response = await this.getTerminalsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getTerminalsWithOngoingPayments without sending the request
     */
    async getTerminalsWithOngoingPaymentsRequestOpts(requestParameters: GetTerminalsWithOngoingPaymentsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['locationId'] == null) {
            throw new runtime.RequiredError(
                'locationId',
                'Required parameter "locationId" was null or undefined when calling getTerminalsWithOngoingPayments().'
            );
        }

        if (requestParameters['ids'] == null) {
            throw new runtime.RequiredError(
                'ids',
                'Required parameter "ids" was null or undefined when calling getTerminalsWithOngoingPayments().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/locations/{locationId}/terminals/with-ongoing-payments`;
        urlPath = urlPath.replace('{locationId}', encodeURIComponent(String(requestParameters['locationId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getTerminalsWithOngoingPaymentsRaw(requestParameters: GetTerminalsWithOngoingPaymentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TerminalWithLatestPaymentResponse>>> {
        const requestOptions = await this.getTerminalsWithOngoingPaymentsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TerminalWithLatestPaymentResponseFromJSON));
    }

    /**
     */
    async getTerminalsWithOngoingPayments(requestParameters: GetTerminalsWithOngoingPaymentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TerminalWithLatestPaymentResponse>> {
        const response = await this.getTerminalsWithOngoingPaymentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for initiateCancelAll without sending the request
     */
    async initiateCancelAllRequestOpts(requestParameters: InitiateCancelAllRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['locationId'] == null) {
            throw new runtime.RequiredError(
                'locationId',
                'Required parameter "locationId" was null or undefined when calling initiateCancelAll().'
            );
        }

        if (requestParameters['paymentReference'] == null) {
            throw new runtime.RequiredError(
                'paymentReference',
                'Required parameter "paymentReference" was null or undefined when calling initiateCancelAll().'
            );
        }

        if (requestParameters['cancelTerminalPaymentBody'] == null) {
            throw new runtime.RequiredError(
                'cancelTerminalPaymentBody',
                'Required parameter "cancelTerminalPaymentBody" was null or undefined when calling initiateCancelAll().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/locations/{locationId}/payments/{paymentReference}/cancel-all`;
        urlPath = urlPath.replace('{locationId}', encodeURIComponent(String(requestParameters['locationId'])));
        urlPath = urlPath.replace('{paymentReference}', encodeURIComponent(String(requestParameters['paymentReference'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CancelTerminalPaymentBodyToJSON(requestParameters['cancelTerminalPaymentBody']),
        };
    }

    /**
     */
    async initiateCancelAllRaw(requestParameters: InitiateCancelAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.initiateCancelAllRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async initiateCancelAll(requestParameters: InitiateCancelAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.initiateCancelAllRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for initiateCancelAppSwitch without sending the request
     */
    async initiateCancelAppSwitchRequestOpts(requestParameters: InitiateCancelAppSwitchRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['locationId'] == null) {
            throw new runtime.RequiredError(
                'locationId',
                'Required parameter "locationId" was null or undefined when calling initiateCancelAppSwitch().'
            );
        }

        if (requestParameters['paymentReference'] == null) {
            throw new runtime.RequiredError(
                'paymentReference',
                'Required parameter "paymentReference" was null or undefined when calling initiateCancelAppSwitch().'
            );
        }

        if (requestParameters['cancelTerminalPaymentBody'] == null) {
            throw new runtime.RequiredError(
                'cancelTerminalPaymentBody',
                'Required parameter "cancelTerminalPaymentBody" was null or undefined when calling initiateCancelAppSwitch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/locations/{locationId}/payments/{paymentReference}/cancel-app-switch`;
        urlPath = urlPath.replace('{locationId}', encodeURIComponent(String(requestParameters['locationId'])));
        urlPath = urlPath.replace('{paymentReference}', encodeURIComponent(String(requestParameters['paymentReference'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CancelTerminalPaymentBodyToJSON(requestParameters['cancelTerminalPaymentBody']),
        };
    }

    /**
     */
    async initiateCancelAppSwitchRaw(requestParameters: InitiateCancelAppSwitchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.initiateCancelAppSwitchRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async initiateCancelAppSwitch(requestParameters: InitiateCancelAppSwitchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.initiateCancelAppSwitchRaw(requestParameters, initOverrides);
    }

}
